var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4985 16.7941V11.063V8.20541C19.4985 6.71314 18.2849 5.5 16.7926 5.5H8.20443C6.71217 5.5 5.49902 6.71314 5.49902 8.20541V11.063V16.7941C5.49902 18.2869 6.71217 19.5 8.20443 19.5H16.7931C18.2849 19.5 19.4985 18.2869 19.4985 16.7941ZM14.9632 12.4993C14.9632 13.8582 13.8562 14.9632 12.4983 14.9632C11.1399 14.9632 10.0338 13.8577 10.0353 12.4988C10.0358 11.9623 10.2098 11.4671 10.5013 11.0625C10.95 10.4418 11.6773 10.0353 12.4998 10.0353C13.3218 10.0353 14.0495 10.4423 14.4972 11.063C14.7877 11.4676 14.9632 11.9628 14.9632 12.4993ZM17.8789 9.48499V7.41961V7.11224L17.57 7.11323L15.5056 7.11967L15.5135 9.49292L17.8789 9.48499ZM12.4988 16.3281C14.6103 16.3281 16.3276 14.6097 16.3276 12.4993C16.3276 11.9916 16.225 11.5062 16.043 11.063H18.1337V16.7941C18.1337 17.5348 17.5313 18.1347 16.7921 18.1347H8.20394C7.46375 18.1347 6.86239 17.5348 6.86239 16.7941V11.063H8.95205C8.77159 11.5062 8.67045 11.9916 8.67045 12.4993C8.67045 14.6097 10.3873 16.3281 12.4988 16.3281Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_40",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 15,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4985 16.7941V11.063V8.20541C19.4985 6.71314 18.2849 5.5 16.7926 5.5H8.20443C6.71217 5.5 5.49902 6.71314 5.49902 8.20541V11.063V16.7941C5.49902 18.2869 6.71217 19.5 8.20443 19.5H16.7931C18.2849 19.5 19.4985 18.2869 19.4985 16.7941ZM14.9632 12.4993C14.9632 13.8582 13.8562 14.9632 12.4983 14.9632C11.1399 14.9632 10.0338 13.8577 10.0353 12.4988C10.0358 11.9623 10.2098 11.4671 10.5013 11.0625C10.95 10.4418 11.6773 10.0353 12.4998 10.0353C13.3218 10.0353 14.0495 10.4423 14.4972 11.063C14.7877 11.4676 14.9632 11.9628 14.9632 12.4993ZM17.8789 9.48499V7.41961V7.11224L17.57 7.11323L15.5056 7.11967L15.5135 9.49292L17.8789 9.48499ZM12.4988 16.3281C14.6103 16.3281 16.3276 14.6097 16.3276 12.4993C16.3276 11.9916 16.225 11.5062 16.043 11.063H18.1337V16.7941C18.1337 17.5348 17.5313 18.1347 16.7921 18.1347H8.20394C7.46375 18.1347 6.86239 17.5348 6.86239 16.7941V11.063H8.95205C8.77159 11.5062 8.67045 11.9916 8.67045 12.4993C8.67045 14.6097 10.3873 16.3281 12.4988 16.3281Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.499023,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.33e98e9e8ab3c754ab55fdd198ac2fd4.svg";
export { ForwardRef as ReactComponent };